import React from 'react';

type ManagedFolderOpenIconProps = {
	label: string;
	size?: 'small' | 'medium';
	color?: string;
};

/**
 * Custom icon for a managed (synced) open folder.
 * Renders an open folder with a circle badge in the bottom-right corner.
 * Uses currentColor so the icon responds to theming and dark mode.
 */
const ManagedFolderOpenIcon = ({ label, size = 'medium', color }: ManagedFolderOpenIconProps) => {
	const dimensions = size === 'small' ? 16 : 24;
	const fillColor = color || 'currentColor';
	return (
		<svg
			width={dimensions}
			height={dimensions}
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			role={label ? 'img' : 'presentation'}
			aria-label={label || undefined}
			aria-hidden={!label}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7.31055 2.75H12C13.1046 2.75 14 3.64543 14 4.75V6H14.6599C15.5809 6 16.2416 6.88783 15.9771 7.77002L15.3081 10H13.7419L14.4919 7.5H4.55811L2.75806 13.5H10V15H1.75C0.783502 15 0 14.2165 0 13.25V3C0 1.89543 0.895431 1 2 1H5.56055L7.31055 2.75ZM2 2.5C1.72386 2.5 1.5 2.72386 1.5 3V12.4731L3.14795 6.97998C3.32243 6.39838 3.85788 6 4.46509 6H12.5V4.75C12.5 4.47386 12.2761 4.25 12 4.25H6.68945L4.93945 2.5H2Z"
				fill={fillColor}
			/>
			<path
				d="M15.75 13.75C15.75 14.8546 14.8546 15.75 13.75 15.75C12.6454 15.75 11.75 14.8546 11.75 13.75C11.75 12.6454 12.6454 11.75 13.75 11.75C14.8546 11.75 15.75 12.6454 15.75 13.75Z"
				fill={fillColor}
			/>
		</svg>
	);
};

export { ManagedFolderOpenIcon };
